import { FC } from 'react';
import { GamesSection } from '../components/GamesSection';
import { Gamepad } from 'lucide-react';
import { motion } from 'framer-motion';

const Games: FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4 py-8">
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="flex items-center gap-3 mb-8"
        >
          <Gamepad className="w-8 h-8 text-primary animate-pulse" />
          <h1 className="text-3xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
            Juegos Educativos
          </h1>
        </motion.div>
        
        <div className="space-y-8">
          {/* Nivel Básico */}
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <h2 className="text-xl font-bold mb-6 flex items-center gap-2">
              <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">Nivel Básico</span>
              <span>Primeros Pasos</span>
            </h2>
            <GamesSection difficulty="basic" />
          </div>

          {/* Nivel Intermedio */}
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <h2 className="text-xl font-bold mb-6 flex items-center gap-2">
              <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-sm">Nivel Intermedio</span>
              <span>Conceptos Avanzados</span>
            </h2>
            <GamesSection difficulty="intermediate" />
          </div>

          {/* Nivel Avanzado */}
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <h2 className="text-xl font-bold mb-6 flex items-center gap-2">
              <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm">Nivel Avanzado</span>
              <span>Experto Financiero</span>
            </h2>
            <GamesSection difficulty="advanced" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Games;